export const RECEIVED_PROFILE = 'RECEIVED_PROFILE'

// export const RECEIVE_PROFILE = 'RECEIVE_PROFILE'

export const SET_TOP_MESSAGE = 'SET_TOP_MESSAGE'

export const SET_PROGRESS_BAR_STATE = 'SET_PROGRESS_BAR_STATE'
